import { style } from '@vanilla-extract/css'

const section = style({
  backgroundColor: 'white',
})

const image = style({
  width: '100%',
})

const heading = style({
  fontFamily: 'Noto Sans Variable, sans-serif',
  fontSize: '19px',
  fontWeight: '700',
  lineHeight: '1.5',
  textAlign: 'center',
})

const text = style({
  fontSize: '15px',
  lineHeight: '1.5',
})

const subheading = style({
  fontSize: '16px',
  fontWeight: '700',
  marginTop: '16px',
});

const sampleImages = style({
  display: 'grid',
  gap: '16px',
  gridTemplate: 'repeat(2, 1fr) / repeat(2, 1fr)',
});

const sampleImage = style({
  cursor: 'pointer',
  aspectRatio: '4 / 5',
  objectFit: 'cover',
  borderRadius: '12px',
})

const modalImage = style({
  width: '100%',
  aspectRatio: '4 / 5',
  objectFit: 'cover',
})

const modalDetails = style({
  margin: '24px',
})

const modalDetailsDt = style({
  fontSize: '16px',
  fontWeight: '700',
  marginBottom: '4px',
})

const modalDetailsDd = style({
  fontSize: '15px',
  marginBottom: '16px',
})

export const styles = {
  section,
  image,
  heading,
  text,
  subheading,
  sampleImages,
  sampleImage,
  modalImage,
  modalDetails,
  modalDetailsDt,
  modalDetailsDd,
}
